import { mapCatalog } from "@/api/mapping/products";

export default function ($api) {
    return {
        /**
         * Получение списка избранных товаров
         * @param { String } query
         * @returns {*}
         */
        getAll(query = "") {
            return $api
                .get(`api/favorite-product/get?sorts=popular&filters[eol][null]=1` + query)
                .then(mapCatalog);
        },
        /**
         * Добавление товара в избранное
         * @param productId
         * @returns {*}
         */
        add(productId) {
            return $api.post("api/favorite-product/add/", { productId });
        },
        /**
         * Удаление товара из избранного
         * @param productId
         * @returns {*}
         */
        remove(productId) {
            return $api.post("api/favorite-product/remove/", { productId });
        },
        /**
         * Удаление всех товаров из избранного
         * @returns {*}
         */
        removeAll() {
            return $api.post("api/favorite-product/remove-all/");
        },
    };
}
